// Client kit 
AAPI = '29e347e16eb64182b3e57e4488365a7d';


RC = (function() {


	var phone;



    return {


        getPhone : function(){
        	return this.phone;
        }

            
    };
     

})();

var SUBKIT = (function() {
	var mgmtSystemId;
	var claimRow;
	var readCodesEdit;
	var readCodes;
	var updateTable;
	var claimRow;
	var header;
	var token;
	var userFrom;
	var stompClient;
	var addyPt;

    return {
        getPMSId: function() {
            return this.mgmtSystemId; // this function can access my_var
        },
        getReadCodes: function() {
            return this.readCodes; // this function can access my_var
        },
    	removeReadCode: function(rowI) {
    		this.readCodes.splice(rowI, 1);
        },
        getUpdateTable: function() {
            return this.updateTable; // this function can access my_var
        },
        getClaimRow: function() {
            return this.claimRow; // this function can access my_var
        },
        getHeader: function() {
            return this.header; // this function can access my_var
        },
        getToken: function() {
            return this.token; // this function can access my_var
        },
        getFrom: function() {
            return this.userFrom; // this function can access my_var
        },
        getStompClient: function(){
        	return this.stompClient;
        },
        getAddyPt: function(){
        	return this.addyPt;
        }
            
    };
     

})();

$(document).ready(function() {
	
    SUBKIT.token = $("meta[name='_csrf']").attr("content");
    SUBKIT.header = $("meta[name='_csrf_header']").attr("content");
	
	SUBKIT.userFrom = $('#userEmail').val();
	if ($('#default-mgmtSystemId').val()){
		SUBKIT.mgmtSystemId =$('#default-mgmtSystemId').val();
	} else {
		SUBKIT.mgmtSystemId = $('#mgmt-system-select').val();
	}
	
	RC.phone = $("#phone-table > tbody > tr").length-1;
	
	$.ajaxSetup({
		  beforeSend: function(xhr) {
	        xhr.setRequestHeader(SUBKIT.getHeader(), SUBKIT.getToken());
	    	}
	});	
	

});


var checkConnection = function(){
    if(!SUBKIT.getStompClient() || !SUBKIT.getStompClient().connected){
        connect();
    }  else if (SUBKIT.getStompClient() && SUBKIT.getStompClient().connected){
       	// do nothing if connected
    } else  {
        setTimeout(checkConnection, 2500); // check again in a second
    }
}
function initAddyAddress(inputId, fieldIds, countryFieldId = null) {
    const inputElement = document.getElementById(inputId);
    if (!inputElement) {
        console.warn(`AddyComplete: Element with ID "${inputId}" not found`);
        return null;
    }

    const addy = new AddyComplete(inputElement);

    // Map the address fields
    addy.fields = {
        address1: document.getElementById(fieldIds.address1),
        address2: document.getElementById(fieldIds.address2),
        suburb:   document.getElementById(fieldIds.suburb),
        city:     document.getElementById(fieldIds.city),
        postcode: document.getElementById(fieldIds.postcode)
    };

    // Only attach addressSelected if a country field is provided
    if (countryFieldId) {
        addy.addressSelected = function(selectedAddress) {
            const countryField = document.getElementById(countryFieldId);
            if (countryField) {
                countryField.value = "New Zealand";
                countryField.dispatchEvent(new Event('change'));
            }
        };
    }

    return addy;
}



